var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_7652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 14C28.5 6.26806 22.2319 0 14.5 0C6.76806 0 0.5 6.26795 0.5 14C0.5 20.9877 5.61963 26.7797 12.3125 27.8299V18.0469H8.75781V14H12.3125V10.9156C12.3125 7.40687 14.4027 5.46875 17.6005 5.46875C19.1322 5.46875 20.7344 5.74219 20.7344 5.74219V9.1875H18.9691C17.2298 9.1875 16.6875 10.2667 16.6875 11.3739V14H20.5703L19.9496 18.0469H16.6875V27.8299C23.3804 26.7797 28.5 20.9879 28.5 14Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9496 18.0469L20.5703 14H16.6875V11.3739C16.6875 10.2666 17.2299 9.1875 18.9691 9.1875H20.7344V5.74219C20.7344 5.74219 19.1322 5.46875 17.6005 5.46875C14.4027 5.46875 12.3125 7.40688 12.3125 10.9156V14H8.75781V18.0469H12.3125V27.8299C13.0361 27.9433 13.7675 28.0002 14.5 28C15.2325 28.0002 15.9639 27.9434 16.6875 27.8299V18.0469H19.9496Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_7652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.62ac4a61c39d28363bff4564fc80337b.svg";
export { ForwardRef as ReactComponent };